import React, {Component, Fragment} from "react";
import * as R from "ramda";
import SimpleModal from "../../../../modules/popup/SimpleModal";
import ModalContainer from "../../../../modules/commons/ModalContainer";
import {Tab, TabList, TabPanel, Tabs} from "react-tabs";
import StockOpnameHeader from "../components/stockOpnameHeader";
import StockOpnameDetail from "../components/stockOpnameDetail";
import SimpleButton from "../../../../modules/commons/SimpleButton";
import FlexView from "react-flexview";
import StockOpnameAddData from "./stockOpnameAddData";
import StockOpnameFooter from "../components/stockOpnameFooter";
import withFormGroup from "../../../../modules/commons/withFormGroup";
import {contructQueryParam, fetchDataAsync} from "../../../../Services/Utils";
import {
    constructDataQrGift,
    constructDataQrPart,
    constructDataQrOtherItem,
    constructGenSeqPayload,
    constructRequestBodySubmitAddData,
    constructRequestBodySubmitProcess,
    fetchDataDetailStockOpname,
    fetchSubmitAddDataDetailStockOpname,
    parseBarcodeData,
} from "../service";
import SimpleLoadingOverlay from "../../../../modules/popup/SimpleLoadingOverlay";
import {Scanner} from "@yudiel/react-qr-scanner";
import SimpleAlert from "../../../../modules/popup/SimpleAlert";
import {ACTIVITY_TYPE, HttpStatus} from "../../../common/Constants";
import Api from "../../../../Services/Api";

class StockOpnameModifying extends Component {
    constructor(props) {
        super(props);
        this.idUser = props.idUser;
        this.state = {
            loading: false,
            dataTable: [],
            dataTableNonQr: [],
            tempDataTable: [],
            tempDataTableNonQr: [],
            dataForSubmitted: [],
            dataChecked: [],
            totalProcess: {
                totalItem: 0,
                totalScanned: 0,
                totalUnScanned: 0,
            },
            addDataModalVisible: false,
            scannerModalVisible: false,
            alertNoDataTableVisibility: false,
            alertVerifySOVisibility: false,
            rawDetailData: null, 
            confirmSubmitVisible: false,
            pendingReq: null,
            totalProcessNonQr: {
                totalItem: 0,
                totalScanned: 0,
                totalUnScanned: 0
            },
        };
    }

    isCreateMode = () => R.equals(this.props.activityType, ACTIVITY_TYPE.CREATE);

    componentDidMount = async () => {
        this.handleTriggerLoading();

        if (R.equals(this.props.activityType, ACTIVITY_TYPE.CREATE)) {
            let kodeCabang = this.props.selectedCabang;
            let noStockOpname = await this.fetchDataGenerateSeq(
                constructGenSeqPayload(kodeCabang)
            );
            this.props.setValue(
                "noStockOpname",
                !R.isNil(noStockOpname) ? noStockOpname : null
            );
        }

        await fetchDataDetailStockOpname(
            this.props.isProcess,
            this.setState.bind(this),
            this.props.controls.stockOpnameType.value,
            contructQueryParam({
                stockOpnameNo: this.props.controls.noStockOpname.value,
            }),
            this.props.setError
        );
    
        this.setState(prev => {
            // const mapped = prev.dataTableNonQr.map(row => {
            //     const qty = row.qty || 0;

            //     return {
            //         ...row,
            //         actualQty: row.actualQty ?? "",
            //         diffQty: (row.actualQty ?? 0) - qty,
            //         isSaved: row.isSaved ?? false,
            //     };
            // });

            return {
                ...prev,
                dataTableNonQr: prev.dataTableNonQr,
                // totalProcess: this.calculateTotalProcessQR(prev.dataTable),
                totalProcessNonQr: this.calculateTotalNonQR(prev.dataTableNonQr),
            };
        });

        this.handleTriggerLoading();
    };


    handleModalAddDataVisibility = () => {
        this.setState((prevValue) => ({
            ...prevValue,
            addDataModalVisible: !prevValue.addDataModalVisible,
        }));
    };

    handleModalScannerVisibility = () => {
        this.setState((prevValue) => ({
            ...prevValue,
            scannerModalVisible: !prevValue.scannerModalVisible,
        }));
    };

    handleAlertNoDataTableVisibility = () => {
        this.setState((prevValue) => ({
            ...prevValue,
            alertNoDataTableVisibility: !prevValue.alertNoDataTableVisibility,
        }));
    };

    handleAlertVerifySOVisibility = () => {
        this.setState((prevValue) => ({
            ...prevValue,
            alertVerifySOVisibility: !prevValue.alertVerifySOVisibility,
        }));
    };
 
    handleSubmit = async (e) => {
      e.preventDefault();
      const userId = localStorage.getItem("userId");
      const { controls, isProcess } = this.props;
      const { dataTable, dataTableNonQr } = this.state;

      const type = controls?.stockOpnameType?.value?.value || "";
      const kodeCabang = controls?.kodeCabang?.value?.value || "";
      const kodeLocation = controls?.kodeLocation?.value?.value || "";
      const isActiveNonQrTab = ["GIFT", "PART", "OTHER_ITEM"].includes(type);
        
      const mergedData = isActiveNonQrTab
        ? [...(dataTable || []), ...(dataTableNonQr || [])]
        : dataTable || [];

      if (mergedData.length === 0 && !isProcess) {
        this.handleAlertNoDataTableVisibility();
        return;
      }

      let list;

      if (isProcess) {
        list = this.state.dataForSubmitted;
      } else if (isActiveNonQrTab) {
        list = {
          qr: isProcess ? this.state.dataForSubmitted : this.state.dataTable,
          nonQr: this.state.dataTableNonQr,
        };
      } else {
        list = this.state.dataTable;
      }

      let req = constructRequestBodySubmitProcess(
          this.props,
          list,
          userId
      );
      console.log(req);

      if (this.props.validate()) {
            if (this.props.isProcess) {
                this.setState({
                  confirmSubmitVisible: true,
                  pendingReq: req,
                });
                return;
            }
        
            if (R.equals(this.props.activityType, ACTIVITY_TYPE.CREATE)) {
                let res = await fetchDataAsync({
                    asyncFn: () => Api.create("NAGAMAS_TRANSACTION").getVerifyStockOpname(type, kodeCabang, kodeLocation),
                    menuName: "Stock Opname",
                    setError: this.props.setError,
                });
            
                if (res.ok && res.data.status === HttpStatus.SUCCESS && res.data.data) {
                    this.setState({
                      confirmSubmitVisible: true,
                      pendingReq: req,
                    });
                } else {
                    this.handleAlertVerifySOVisibility();
                }
            } else {
                this.setState({
                  confirmSubmitVisible: true,
                  pendingReq: req,
                });
            }
        }
    };

    handleConfirmSubmit = () => {
        console.log("tes");
        
      const { pendingReq } = this.state;
      console.log(pendingReq);
      
        
      this.setState(
        { confirmSubmitVisible: false },
        () => {
          this.props.onSubmit(
            this.props.controls.stockOpnameType.value,
            pendingReq
          );
        }
      );
    };

    handleCancelSubmit = () => {
      this.setState({
        confirmSubmitVisible: false,
        pendingReq: null,
      });
    };

    handleSubmitAddDetailData = async () => {
      this.handleTriggerLoading();

      let requestBody = constructRequestBodySubmitAddData(
        this.props.controls.stockOpnameType.value,
        this.props.controls,
        this.state.dataChecked
      );

      await fetchSubmitAddDataDetailStockOpname(
        this.setState.bind(this),
        this.props.controls.stockOpnameType.value,
        requestBody,
        this.props.setError,
        this.state.rawDetailData,
        this.props.activityType
      );
  
      this.setState(prev => {
        const mapped = prev.dataTableNonQr.map(row => {
          const qty = row.qty || 0;

          const actualValue = 
            row.actualQty !== undefined && row.actualQty !== null
              ? row.actualQty
              : row.actQTY !== undefined && row.actQTY !== null
                ? row.actQTY
                : "";
                  
          const actualNumber = parseInt(actualValue || 0, 10);

          return {
            ...row,
            actualQty: actualValue,
            diffQty: actualNumber - qty,
            isSaved: row.isSaved ?? false,
          };
        });

        return {
          ...prev,
          dataTableNonQr: mapped,
          totalProcess: this.calculateTotalProcessQR(prev.dataTable),
          totalProcessNonQr: this.calculateTotalNonQR(mapped)
        };
      });

      this.handleTriggerLoading();
      this.handleModalAddDataVisibility();
    };


    handleDataCheckedChange = (updatedDataChecked) => {
        this.setState((prevValue) => ({
            ...prevValue,
            dataChecked: updatedDataChecked,
        }));
    };

    handleTriggerLoading = () => {
        this.setState((prevValue) => ({
            ...prevValue,
            loading: !prevValue.loading,
        }));
    };

    handleOnScanQrCode = (data) => {
        this.handleTriggerLoading();
        if (!R.isNil(data)) {
            let barcodeData = parseBarcodeData(data);

            let {dataForSubmitted} = this.state;
            let dataTable = this.filterDataTable(
                this.props.controls.stockOpnameType.value?.value,
                barcodeData
            );
            let index = this.findIndex(
                dataForSubmitted,
                barcodeData,
                this.props.controls.stockOpnameType.value?.value
            );
            let dataForStateSubmitted = this.filterDataForSubmitted(
                dataForSubmitted,
                this.props.controls.stockOpnameType.value?.value,
                barcodeData
            );
            const type = this.props.controls.stockOpnameType.value?.value;
            const temp = ["OTHER_ITEM","GIFT","PART"]?.includes(type) ? dataForStateSubmitted.qr : dataForStateSubmitted
            // if (index !== -1) {
            //     this.setState((prevValue) => ({
            //         ...prevValue,
            //         dataTable: dataTable,
            //         dataForSubmitted: dataForStateSubmitted,
            //         totalProcess: this.calculateTotalProcessQR(temp),
            //     }));
            // }
            const fullData =
              ["OTHER_ITEM", "GIFT", "PART"].includes(type)
                ? (dataForStateSubmitted.qr || [])   // Fallback
                : (Array.isArray(dataForStateSubmitted) ? dataForStateSubmitted : []);

            if (index !== -1) {
                this.setState((prevValue) => {
                    const updatedTable = dataTable; 
                    const fullData = dataForStateSubmitted;
                
                    return {
                        ...prevValue,
                        dataTable: updatedTable,
                        dataForSubmitted: fullData,
                        totalProcess: this.calculateTotalProcessQR(fullData),
                    };
                });
            }

        }
        this.handleModalScannerVisibility();
        this.handleTriggerLoading();
    };

    findIndex = (data, barcodeData, type) => {
        const isHaveNonQr = ["GIFT", "OTHER_ITEM", "PART"].includes(type)
        const sourceData = isHaveNonQr ? data?.qr : data;
        return sourceData.findIndex((item) => {
            switch (type) {
                case "UNIT":
                    return (
                        item.noSinBarcodeEncrypted === barcodeData.rawValue &&
                        item.unitExist === false
                    );
                case "KSU":
                    return (
                        item.ksuBarcodeEncrypted === barcodeData.rawValue &&
                        item.ksuExist === false
                    );
                case "PART":
                    return (
                        item.barcodeEncrypted === barcodeData.rawValue &&
                        item.partExist === false
                    );
                case "GIFT":
                    return (
                        item.giftBarcodeEncrypted === barcodeData.rawValue &&
                        item.giftExist === false
                    );
                case "OTHER_ITEM":
                    return (
                        item.barcodeEncrypted === barcodeData.rawValue &&
                        item.exist === false
                    );
                default:
                    break;
            }
        });
    };

    filterDataTable = (type, barcodeData) => {
        return this.state.dataTable.filter((item) => {
            switch (type) {
                case "UNIT":
                    return item.noSinBarcodeEncrypted !== barcodeData.rawValue;
                case "KSU":
                    return item.ksuBarcodeEncrypted !== barcodeData.rawValue;
                case "PART":
                    return item.barcodeEncrypted !== barcodeData.rawValue;
                case "GIFT":
                    return item.giftBarcodeEncrypted !== barcodeData.rawValue;
                case "OTHER_ITEM":
                    return item.barcodeEncrypted !== barcodeData.rawValue;
                default:
                    return false;
            }
        });
    };

    filterDataForSubmitted = (data, type, barcodeData) => {
        console.log(data);
        
        switch (type) {
            case "UNIT":
                return data.map((item) =>
                    item.noSinBarcodeEncrypted === barcodeData.rawValue
                        ? {
                            ...item, unitExist: true,
                            userId: this.idUser,
                        }
                        : item
                );
            case "KSU":
                return data.map((item) =>
                    item.ksuBarcodeEncrypted === barcodeData.rawValue
                        ? {
                            ...item, ksuExist: true,
                            userId: this.idUser,
                        }
                        : item
                );
            case "GIFT":
                return {
                  ...data,
                  qr: data.qr.map((item) =>
                    item?.giftBarcodeEncrypted === barcodeData.rawValue
                      ? constructDataQrGift({
                          ...item,
                          giftExist: true,
                          userId: this.idUser,
                        })
                      : constructDataQrGift({
                          ...item,
                          userId: item?.userId?.idUser ?? item?.userId ?? null,
                        })
                  ),
                };
            case "PART":
                return {
                  ...data,
                  qr: data.qr.map((item) =>
                    item?.barcodeEncrypted === barcodeData.rawValue
                      ? constructDataQrPart({
                          ...item,
                          partExist: true,
                          userId: this.idUser,
                        })
                      : constructDataQrPart({
                          ...item,
                          userId: item?.userId?.idUser ?? item?.userId ?? null,
                        })
                  ),
                };
            case "OTHER_ITEM":
                return {
                  ...data,
                  qr: data.qr.map((item) =>
                    item?.barcodeEncrypted === barcodeData.rawValue
                      ? constructDataQrOtherItem({
                          ...item,
                          exist: true,
                          userId: this.idUser,
                        })
                      : constructDataQrOtherItem({
                          ...item,
                          userId: item?.userId?.idUser ?? item?.userId ?? null,
                        })
                  ),
                };
            default:
                return data;
        }
    };

    fetchDataGenerateSeq = async (body) => {
        try {
            let res = await Api.create("NAGAMAS_MASTER_DATA").generateSeqWithoutSave(
                body
            );
            if (res.ok) {
                return res.data;
            }
        } catch (error) {
            console.log("errors: ", error);
        }
    };

    handleChangeData = (index, name, value) => {
      this.setState((prev) => {
        const updated = [...prev.dataTableNonQr];
        const row = { ...updated[index] };
        const qty = Number(row.qty) || 0;
    
        const isActualField = name === "actualQty" || name === "actQTY";
        const actual = isActualField
            ? (value === "" ? 0 : Number(value))
            : Number(row.actualQty ?? row.actQTY ?? 0);

        
        updated[index] = {
          ...row,
          actualQty: isActualField ? actual : row.actualQty,
          actQTY: isActualField ? actual : row.actQTY,
          [name]: value,
          diffQty: actual === "" ? "" : actual - qty,
        };
        console.log(updated);

        return {
          ...prev,
          dataTableNonQr: updated,
          dataForSubmitted: {
            ...prev.dataForSubmitted,
            nonQr: updated,
          },
          totalProcessNonQr: this.calculateTotalNonQR(updated),
        };
      });
    };

    calculateTotalNonQR = (data) => {
      const totalUnScanned = data.length;

      if (this.isCreateMode()) {
        return {
          totalItem: totalUnScanned,
          totalScanned: 0,
          totalUnScanned,
        };
      }
  
      const totalScanned = data.filter(item => item.isSaved === true).length;

      return {
        totalItem: data.length,
        totalScanned,
        totalUnScanned: data.length - totalScanned,
      };
    };

    // calculateTotalProcessQR = (dataTable) => {
    //   const totalUnScanned = dataTable.length;
        
    //   if (this.isCreateMode()) {
    //     return {
    //       totalItem: totalUnScanned,
    //       totalScanned: 0,
    //       totalUnScanned,
    //     };
    //   }
  
    //   const totalScanned = dataTable.filter(
    //     x => x.unitExist || x.ksuExist || x.partExist || x.giftExist || x.exist
    //   ).length;

    //   return {
    //     totalItem: dataTable.length,
    //     totalScanned,
    //     totalUnScanned: dataTable.length - totalScanned,
    //   };
    // };

    calculateTotalProcessQR = (raw) => {
      if (!raw) return {
        totalItem: 0,
        totalScanned: 0,
        totalUnScanned: 0
      };
  
      let list = [];

      if (Array.isArray(raw)) {
        list = raw;                       
      } else if (Array.isArray(raw?.qr)) {
        list = raw.qr;                    
      }

      const totalItem = list.length;

      const totalScanned = list.filter(x =>
        x.unitExist || x.ksuExist || x.partExist || x.giftExist || x.exist
      ).length;

      const totalUnScanned = totalItem - totalScanned;

      return {
        totalItem,
        totalScanned,
        totalUnScanned
      };
    };
    
    handleDelteRow = (index) => {
      this.setState((prev) => {
        const updated = prev.dataTableNonQr.filter((_, idx) => idx !== index);
        console.log(updated);
        

        const updatedDataForSubmitted = {
          ...prev.dataForSubmitted,
          nonQr: prev.dataForSubmitted?.nonQr?.filter((_, idx) => idx !== index)
        };

        return {
          ...prev,
          dataTableNonQr: updated,
          dataForSubmitted: updatedDataForSubmitted,
          totalProcessNonQr: this.calculateTotalNonQR(updated)
        };
      });
    };


    resetTable = () => {
        this.setState(prev=>({
            ...prev,
            dataTable: [],
            dataTableNonQr: []
        }))
    }

    render() {
        return (
            <Fragment>
                <SimpleModal
                    title="Tambah Data SOP"
                    visible={this.props.visible}
                    onClickClose={() => this.props.onClickClose()}
                    content={
                        <ModalContainer>
                            <form onSubmit={this.handleSubmit}>
                                <FlexView column marginBottom={20}>
                                    <StockOpnameHeader
                                        {...this.props}
                                        resetTable={this.resetTable}
                                        dataChecked={this.state.dataChecked}
                                    />

                                    {!this.props.isProcess && (
                                        <SimpleButton
                                            className="margin-left-none"
                                            type="button"
                                            text="Tambah"
                                            onClick={() => this.handleModalAddDataVisibility()}
                                        />
                                    )}
                                </FlexView>

                                {this.props.isProcess && (
                                    <FlexView style={{justifyContent: "end"}}>
                                        <SimpleButton
                                            type="button"
                                            category="action_button"
                                            icon={
                                                <i
                                                    style={{fontSize: 28, color: "red"}}
                                                    className="fa fa-lw fa-qrcode"
                                                />
                                            }
                                            onClick={() => this.handleModalScannerVisibility()}
                                        />
                                    </FlexView>
                                )}

                                <Tabs>
                                    <TabList >
                                        <Tab id="button_navigate_dgi">Dengan QR</Tab>
                                        <Tab
                                            id="button_navigate_nos"
                                            disabled={
                                                !R.isNil(this.props.controls.stockOpnameType) &&
                                                (this.props.controls.stockOpnameType?.value?.value ===
                                                    "UNIT" ||
                                                    this.props.controls.stockOpnameType?.value?.value ===
                                                    "KSU")
                                            }
                                        >
                                            Tanpa QR
                                        </Tab>
                                    </TabList>
                                    <TabPanel>
                                        <StockOpnameDetail
                                            tab="with_qr"
                                            {...this.props}
                                            totalProcess={this.state.totalProcess}
                                            dataTable={this.state.dataTable}
                                        />
                                    </TabPanel>
                                    <TabPanel>
                                        <StockOpnameDetail
                                            tab="without_qr"
                                            {...this.props}
                                            onDataTableChange={this.handleChangeData}
                                            onDeleteRow={this.handleDelteRow}
                                            dataTable={this.state.dataTableNonQr}
                                            totalProcess={this.state.totalProcessNonQr}
                                        />
                                    </TabPanel>
                                </Tabs>

                                <FlexView style={{justifyContent: "end"}}>
                                    <SimpleButton
                                        // secondary
                                        type="submit"
                                        className="margin-left-none"
                                        text="Proses"
                                    />
                                </FlexView>
                            </form>

                            {this.state.addDataModalVisible && (
                                <StockOpnameAddData
                                    {...this.props}
                                    dataForSubmitted={this.state.dataForSubmitted}
                                    dataChecked={this.state.dataChecked}
                                    selectedData={this.props.selectedData}
                                    visible={this.state.addDataModalVisible}
                                    rawDetailData={this.state.rawDetailData}
                                    onClickClose={this.handleModalAddDataVisibility}
                                    onDataCheckedChange={this.handleDataCheckedChange}
                                    onSubmit={this.handleSubmitAddDetailData}
                                />
                            )}

                            {this.state.alertNoDataTableVisibility && (
                                <SimpleAlert
                                    title={"Peringatan"}
                                    visible={this.state.alertNoDataTableVisibility}
                                    onClickClose={this.handleAlertNoDataTableVisibility}
                                    content={
                                        <div>
                                            <p>
                                                Terdapat data yang belum lengkap, mohon periksa kembali!
                                            </p>
                                            <SimpleButton
                                                styles={{marginTop: "10px"}}
                                                onClick={this.handleAlertNoDataTableVisibility}
                                            >
                                                OK
                                            </SimpleButton>
                                        </div>
                                    }
                                />
                            )}

                            {this.state.alertVerifySOVisibility && (
                                <SimpleAlert
                                    title={"Peringatan"}
                                    visible={this.state.alertVerifySOVisibility}
                                    onClickClose={this.handleAlertVerifySOVisibility}
                                    content={
                                        <div>
                                            <p>
                                                Terdapat surat stock opname dengan item dan lokasi yang sama di resolve, harap di resolve terlebih dahulu untuk bisa membuat dokumen stock opname baru
                                            </p>
                                            <SimpleButton
                                                styles={{marginTop: "10px"}}
                                                onClick={this.handleAlertVerifySOVisibility}
                                            >
                                                OK
                                            </SimpleButton>
                                        </div>
                                    }
                                />
                            )}

                            {this.state.scannerModalVisible && (
                                <SimpleAlert
                                    title={"Scan QR Here"}
                                    visible={this.state.scannerModalVisible}
                                    onClickClose={this.handleModalScannerVisibility}
                                    additionalButtons={
                                        <Scanner
                                            onScan={(result) => this.handleOnScanQrCode(result)}
                                            constraints={{
                                                height: {ideal: "720"},
                                                video: {
                                                    facingMode: {ideal: "environment"},
                                                    height: {ideal: 720}
                                                },
                                            }}
                                        />
                                    }
                                />
                            )}

                            {this.state.confirmSubmitVisible && (
                              <SimpleAlert
                                title="Konfirmasi"
                                content={"Apakah Anda yakin?"}
                                visible={this.state.confirmSubmitVisible}
                                onClickClose={this.handleCancelSubmit}
                                additionalButtons={
                                  <FlexView style={{ gap: "15px" }}>
                                    <SimpleButton
                                      secondary
                                      text="Batal"
                                      onClick={this.handleCancelSubmit}
                                    />

                                    <SimpleButton
                                      text="Iya"
                                      onClick={this.handleConfirmSubmit}
                                    />
                                  </FlexView>
                                }
                              />
                            )}

                        </ModalContainer>
                    }
                />

                <SimpleLoadingOverlay active={this.state.loading}/>
            </Fragment>
        );
    }
}

export default withFormGroup(StockOpnameModifying);
